module.exports = __webpack_public_path__ + "static/media/10.af2f7eec.jpg";